import { BudgetInformationFormFragment } from 'generated/resources/graphql'

export const getBudgetDefaultValues = (data?: BudgetInformationFormFragment | null) => {
  const id = data?.bugdetMovement?.budget?.id
  return {
    budgetId: id && id !== '0' ? id : null,
  }
}
